import app from '../../forum/app';
import PaginatedListState from '../../common/states/PaginatedListState';
export default class NotificationListState extends PaginatedListState {
  constructor() {
    super({}, 1, null);
  }
  get type() {
    return 'notifications';
  }

  /**
   * Load the next page of notification results.
   */
  load() {
    var _app$session$user, _app$session$user2;
    if ((_app$session$user = app.session.user) != null && _app$session$user.newNotificationCount()) {
      this.pages = [];
      this.location = {
        page: 1
      };
    }
    if (this.pages.length > 0) {
      return Promise.resolve();
    }
    (_app$session$user2 = app.session.user) == null || _app$session$user2.pushAttributes({
      newNotificationCount: 0
    });
    return super.loadNext();
  }

  /**
   * Mark all of the notifications as read.
   */
  markAllAsRead() {
    var _app$session$user3;
    if (this.pages.length === 0) return;
    (_app$session$user3 = app.session.user) == null || _app$session$user3.pushAttributes({
      unreadNotificationCount: 0
    });
    this.pages.forEach(page => {
      page.items.forEach(notification => notification.pushAttributes({
        isRead: true
      }));
    });
    return app.request({
      url: app.forum.attribute('apiUrl') + '/notifications/read',
      method: 'POST'
    });
  }

  /**
   * Delete all of the notifications for this user.
   */
  deleteAll() {
    var _app$session$user4;
    if (this.pages.length === 0) return;
    (_app$session$user4 = app.session.user) == null || _app$session$user4.pushAttributes({
      unreadNotificationCount: 0
    });
    this.pages = [];
    return app.request({
      url: app.forum.attribute('apiUrl') + '/notifications',
      method: 'DELETE'
    });
  }
}
flarum.reg.add('core', 'forum/states/NotificationListState', NotificationListState);